import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getblog, createblog, updateblog, deleteblogs } from '../../ReduxToolkit/Slice/Blog/BlogSlice';
import JoditEditor from 'jodit-react';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';


function Blog() {
  const dispatch = useDispatch();
  const { status, blogs } = useSelector((state) => state.blog);
  const [thumbnail, setThumbnail] = useState(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [slugUrl, setSlugUrl] = useState("");
  const [MetaTitle, setMetaTitle] = useState("");
  const [Metakeyword, setMetakeyword] = useState("");
  const [MetaDescription, setMetaDescription] = useState("");
  const closeButtonRef = useRef(null);
  const [isDescriptionValid, setIsDescriptionValid] = useState(true);
  // create
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!content) {
      setIsDescriptionValid(false);
      return;
    }
    setIsDescriptionValid(true);
    const formData = new FormData();
    formData.append('thumbnail', thumbnail === null ? "" : thumbnail);
    formData.append('title', title);
    formData.append('content', content);
    formData.append('slugUrl', slugUrl);
    formData.append('MetaTitle', MetaTitle);
    formData.append('Metakeyword', Metakeyword);
    formData.append('MetaDescription', MetaDescription);
    dispatch(createblog(formData));
    setThumbnail(null);
    setTitle("");
    setContent("");
    setSlugUrl("");
    setMetaTitle("");
    setMetakeyword("");
    setMetaDescription("");
    closeButtonRef.current.click();


  };
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getblog())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (blogid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Blog?")
    if (Isconfirmed) {
      dispatch(deleteblogs(blogid))
    };
  }
  // single data fetch
  const [updateButton, setupdateButton] = useState("d-none")
  const [SubmitButton, setSubmitButton] = useState("")
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selecteblog = blogs.data.find(blog => blog._id === id);
    setTitle(selecteblog.title);
    setThumbnail(selecteblog.thumbnail);
    setContent(selecteblog.content);
    setSlugUrl(selecteblog.slugUrl);
    setMetaTitle(selecteblog.MetaTitle);
    setMetakeyword(selecteblog.Metakeyword);
    setMetaDescription(selecteblog.MetaDescription);
    setSelectedId(id);
    if (selecteblog) {
      setupdateButton("")
      setSubmitButton("d-none")
    }
    else { }
  };
  // update
  const handleEdit = () => {
    const formData = new FormData();
    formData.append('thumbnail', thumbnail === null ? "" : thumbnail);
    formData.append('title', title);
    formData.append('content', content);
    formData.append('slugUrl', slugUrl);
    formData.append('MetaTitle', MetaTitle);
    formData.append('Metakeyword', Metakeyword);
    formData.append('MetaDescription', MetaDescription);
    dispatch(updateblog({ selectedId, formData }));
    setThumbnail(null);
    setTitle("");
    setContent("");
    setSlugUrl("");
    setMetaTitle("");
    setMetakeyword("");
    setMetaDescription("");
  }
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const columns = [
    { label: "Title", accessor: "title" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },

  ];
  return (
    <>
      <div>
        <ToastContainer/>
        <div className='d-flex justify-content-between my-3'>
          <h3>Blogs </h3>
          <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  Blgos </button>
        </div>
        <CommanTable
                    columns={columns}
                    data={blogs.data || []}
                    status={status}
                    onDelete={handleDelete}
                    onEdit={handlid}
                    databstarget="#exampleModal"
                    model="modal"
                />
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload blog
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="mb-3 col-lg-6">
                    {/* <img src={thumbnail} className='img-fluid rounded' alt="" /> */}
                    <label htmlFor="thumbnail" className="form-label">
                      Thumbnail
                    </label>
                    <input
                      type="file"
                      required
                      className="form-control"
                      id="thumbnail"
                      name="thumbnail"
                      // value={thumbnail}
                      onChange={(e) => setThumbnail(e.target.files[0])}
                    />
                  </div>
                  <div className="mb-3 col-lg-6">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="title"
                      name="title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Title"
                    />
                  </div>

                  <div className="mb-3 col-lg-6">
                    <label htmlFor="slugUrl" className="form-label">
                      Slug URL
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="slugUrl"
                      name="slugUrl"
                      value={slugUrl}
                      onChange={(e) => setSlugUrl(e.target.value)}
                      placeholder="Slug URL"
                    />
                  </div>
                  <div className="mb-3 col-lg-6">
                    <label htmlFor="MetaTitle" className="form-label">
                      Meta Title
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="MetaTitle"
                      name="MetaTitle"
                      value={MetaTitle}
                      onChange={(e) => setMetaTitle(e.target.value)}
                      placeholder="Meta Title"
                    />
                  </div>
                  <div className="mb-3 col-lg-6">
                    <label htmlFor="Metakeyword" className="form-label">
                      Meta Keyword
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="Metakeyword"
                      name="Metakeyword"
                      value={Metakeyword}
                      onChange={(e) => setMetakeyword(e.target.value)}
                      placeholder="Meta Keyword"
                    />
                  </div>
                  <div className="mb-3 col-lg-6">
                    <label htmlFor="MetaDescription" className="form-label">
                      Meta Description
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="MetaDescription"
                      name="MetaDescription"
                      value={MetaDescription}
                      onChange={(e) => setMetaDescription(e.target.value)}
                      placeholder="Meta Description"
                    />
                  </div>
                  <div className="mb-3 col-lg-12">
                    <label htmlFor="content" className="form-label">
                      Content
                    </label>
                    <JoditEditor
                      required={true}
                      value={content}
                      tabIndex={1} // 
                      onBlur={newContent => setContent(newContent)}
                      onChange={newContent => { }}
                    />
                  </div>
                  <div className={`modal-footer ${SubmitButton}`}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      ref={closeButtonRef}
                    >
                      Close
                    </button>
                    <button type="submit" className={`btn btn-primary`}   >
                      Upload
                    </button>
                  </div>
                </div>
              </form>
              <div className={`modal-footer ${updateButton}`}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" onClick={handleEdit} className={`btn btn-primary`} data-bs-dismiss="modal"  >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;
